import classNames from 'classnames'
import multiselectStyles from 'common/MultiselectDropdown/index.module.scss'

export type OptionsPanelProps = {
  options: ProviderFilter[]
  selectedIds: string[]
  onToggle: (option: ProviderFilter, currentlySelected: boolean) => void
  listItemIdPrefix: string
  containerClassName?: string
  disabled?: boolean
  /** `compact` uses tighter padding for narrow pill menus. */
  paddingSize?: 'default' | 'compact'
  /** When true, uses Navy (#14467C) styling for checkboxes (calendar filter modal). */
  useNavyCheckbox?: boolean
}

const NAVY_CHECKBOX_CLASSES =
  '~h-5 ~w-5 ~min-w-[20px] ~rounded-[3px] ~border ~border-[#14467c] ~bg-white ~p-0 ~appearance-none ~cursor-pointer ~shrink-0'

const NAVY_CHECKBOX_CHECKED_CLASSES =
  '~h-5 ~w-5 ~min-w-[20px] ~rounded-[3px] ~border ~border-[#14467c] ~bg-[#14467c] ~p-0 ~appearance-none ~cursor-pointer ~shrink-0'

const NAVY_CHECKBOX_CHECKED_BG_STYLES: React.CSSProperties = {
  backgroundImage: "url('/icons/checkbox-icon.svg')",
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: '12px',
}

/**
 * Checklist body shared by the pill dropdown and `variant="panel-only"` layouts.
 */
const OptionsPanel: React.FC<OptionsPanelProps> = ({
  options,
  selectedIds,
  onToggle,
  listItemIdPrefix,
  containerClassName,
  disabled = false,
  paddingSize = 'default',
  useNavyCheckbox = false,
}) => (
  <div
    className={classNames(
      paddingSize === 'compact'
        ? multiselectStyles.dropdown_padding_compact
        : multiselectStyles.dropdown_padding,
      containerClassName
    )}
  >
    <div
      className={classNames(
        multiselectStyles.list_max_height,
        multiselectStyles.multiselect_filter,
        '~flex ~flex-col ~gap-4'
      )}
    >
      {options.map((option) => {
        const isSelected = selectedIds.includes(option.id)

        return (
          <div key={option.id}>
            <label
              htmlFor={`${listItemIdPrefix}-${option.id}`}
              className="~mb-0 ~flex ~items-center ~cursor-pointer ~select-none"
            >
              <input
                id={`${listItemIdPrefix}-${option.id}`}
                type="checkbox"
                checked={isSelected}
                disabled={disabled}
                style={
                  useNavyCheckbox && isSelected
                    ? NAVY_CHECKBOX_CHECKED_BG_STYLES
                    : undefined
                }
                className={
                  useNavyCheckbox
                    ? isSelected
                      ? NAVY_CHECKBOX_CHECKED_CLASSES
                      : NAVY_CHECKBOX_CLASSES
                    : classNames(multiselectStyles.filter_checkbox_input)
                }
                onChange={() => {
                  if (disabled) {
                    return
                  }

                  onToggle(option, isSelected)
                }}
              />
              <span className="~font-gibson ~text-[14px] ~leading-[18px] ~font-normal ~text-black ~ml-[14px]">
                {option.value}
              </span>
            </label>
            {option.description ? (
              <div className="~ml-[34px] ~text-medium-grey">
                {option.description}
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  </div>
)

export default OptionsPanel
